import React, { useState, useEffect, useRef } from 'react';
import { FaWhatsapp, FaFacebookF, FaXTwitter } from 'react-icons/fa6';
import { FiLink, FiShare2 } from 'react-icons/fi';
import {
  facebookHref,
  whatsappHref,
  xHref,
  canNativeShare,
  copyText,
} from '../../../utils/share';
import { ShareRow, ShareLabel, ShareLink, ShareAction, CopiedNote } from './ShareButtons.styles';

// `url` debe ser siempre una URL /share/... (ver utils/share.js).
const ShareButtons = ({ url, text, title = 'BokerHub', label = 'Compartir' }) => {
  const [status, setStatus] = useState('');
  const timer = useRef(null);
  const nativeShare = canNativeShare();

  useEffect(() => () => clearTimeout(timer.current), []);

  const flash = (message) => {
    setStatus(message);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setStatus(''), 2500);
  };

  const handleCopy = async () => {
    try {
      await copyText(url);
      flash('¡Enlace copiado!');
    } catch (e) {
      flash('No se pudo copiar el enlace');
    }
  };

  const handleNativeShare = async () => {
    try {
      await navigator.share({ title, text, url });
    } catch (e) {
      // AbortError = el usuario cerró el menú de compartir; no es un fallo.
      if (e && e.name !== 'AbortError') flash('No se pudo abrir el menú de compartir');
    }
  };

  return (
    <ShareRow role="group" aria-label={label}>
      {label && <ShareLabel>{label}</ShareLabel>}
      {nativeShare && (
        <ShareAction type="button" onClick={handleNativeShare}>
          <FiShare2 aria-hidden="true" /> Compartir
        </ShareAction>
      )}
      <ShareLink
        href={whatsappHref(text, url)}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Compartir en WhatsApp"
      >
        <FaWhatsapp aria-hidden="true" /> WhatsApp
      </ShareLink>
      <ShareLink
        href={facebookHref(url)}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Compartir en Facebook"
      >
        <FaFacebookF aria-hidden="true" /> Facebook
      </ShareLink>
      <ShareLink
        href={xHref(text, url)}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Compartir en X"
      >
        <FaXTwitter aria-hidden="true" /> X
      </ShareLink>
      <ShareAction type="button" onClick={handleCopy}>
        <FiLink aria-hidden="true" /> Copiar enlace
      </ShareAction>
      <CopiedNote role="status" aria-live="polite">{status}</CopiedNote>
    </ShareRow>
  );
};

export default ShareButtons;
